export default class OptimizelyError extends Error {
  constructor(message: string) {
    super(`Optimizely SDK: ${message}`)

    this.name = 'OptimizelyError'
  }
}
